const cookie = require('cookie-cutter');
const domify = require('domify');
const on = require('emmy/on');
const q = require('queried');
const InViewFactory = require('kudago-in-view');

const { getCsrfToken, debounce } = require('./utils');

class CSRFTokenHandler {
  constructor() {
    this.token = null;
  }

  run() {
    this.addTokenToVisibleForms();

    const debouncedAddTokenToVisibleForms = debounce(() => this.addTokenToVisibleForms(), 500);
    on(document, 'scroll', debouncedAddTokenToVisibleForms);
    on(document, 'click', debouncedAddTokenToVisibleForms);
  }

  addTokenToVisibleForms() {
    const inView = InViewFactory();

    const postForms = q.all('form[method="post"]:not(.tokenized)');
    const visiblePostForms = postForms.filter((form) => inView.is(form));

    if (!visiblePostForms.length) {
      return;
    }

    if (!this.token) {
      getCsrfToken().then((token) => {
        this.token = token;
        this.setToken(token, visiblePostForms);
      });
    } else {
      this.setToken(this.token, visiblePostForms);
    }
  }

  setToken(token, forms) {
    cookie.set('csrftoken', token, { path: '/' });

    forms.map((form) => {
      form.classList.add('tokenized');

      return form.appendChild(domify(`
        <input name="csrfmiddlewaretoken" type="hidden" value="${token}">
      `));
    });
  }
}

module.exports = CSRFTokenHandler;
